import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withSetPropAction } from '../extensions/withSetPropAction';

/**
 * # OperatorInfo
 *
 * 운영자 정보
 */
export const OperatorInfo = types
  .model('OperatorInfo')
  .props({
    oprtrSid: types.maybeNull(types.number),
    loginId: types.maybeNull(types.string),
    oprtrNm: types.maybeNull(types.string),
  })
  .actions(withSetPropAction);
type TOperatorInfo = Instance<typeof OperatorInfo>;
type TOperatorInfoSnapshot = SnapshotOut<typeof OperatorInfo>;

export interface IOperatorInfo extends TOperatorInfo {}
export type TOperatorInfoKeys = keyof TOperatorInfoSnapshot & string;
export interface IOperatorInfoSnapshot extends TOperatorInfoSnapshot {}
export const createOperatorInfo = () =>
  types.optional(OperatorInfo, {
    oprtrSid: null,
    loginId: null,
    oprtrNm: null,
  } as TOperatorInfo);
